// ── Transport layer messages (RFC 4253) ────────────────────────────

export const SSH_MSG_DISCONNECT = 1;
export const SSH_MSG_IGNORE = 2;
export const SSH_MSG_UNIMPLEMENTED = 3;
export const SSH_MSG_DEBUG = 4;
export const SSH_MSG_SERVICE_REQUEST = 5;
export const SSH_MSG_SERVICE_ACCEPT = 6;

// Transport extension negotiation (RFC 8308)
export const SSH_MSG_EXT_INFO = 7;

export const SSH_MSG_KEXINIT = 20;
export const SSH_MSG_NEWKEYS = 21;

// kex method-specific (DH / ECDH)
export const SSH_MSG_KEX_ECDH_INIT = 30;
export const SSH_MSG_KEX_ECDH_REPLY = 31;

// ── Authentication messages (RFC 4252) ─────────────────────────────

export const SSH_MSG_USERAUTH_REQUEST = 50;
export const SSH_MSG_USERAUTH_FAILURE = 51;
export const SSH_MSG_USERAUTH_SUCCESS = 52;
export const SSH_MSG_USERAUTH_BANNER = 53;

// method-specific (message code 60 is reused per auth method)
export const SSH_MSG_USERAUTH_PK_OK = 60;

// ── Connection protocol messages (RFC 4254) ────────────────────────

export const SSH_MSG_GLOBAL_REQUEST = 80;
export const SSH_MSG_REQUEST_SUCCESS = 81;
export const SSH_MSG_REQUEST_FAILURE = 82;

export const SSH_MSG_CHANNEL_OPEN = 90;
export const SSH_MSG_CHANNEL_OPEN_CONFIRMATION = 91;
export const SSH_MSG_CHANNEL_OPEN_FAILURE = 92;
export const SSH_MSG_CHANNEL_WINDOW_ADJUST = 93;
export const SSH_MSG_CHANNEL_DATA = 94;
export const SSH_MSG_CHANNEL_EXTENDED_DATA = 95;
export const SSH_MSG_CHANNEL_EOF = 96;
export const SSH_MSG_CHANNEL_CLOSE = 97;
export const SSH_MSG_CHANNEL_REQUEST = 98;
export const SSH_MSG_CHANNEL_SUCCESS = 99;
export const SSH_MSG_CHANNEL_FAILURE = 100;

// ── Disconnect reason codes (RFC 4253 §11.1) ──────────────────────

export const SSH_DISCONNECT_HOST_NOT_ALLOWED_TO_CONNECT = 1;
export const SSH_DISCONNECT_PROTOCOL_ERROR = 2;
export const SSH_DISCONNECT_KEY_EXCHANGE_FAILED = 3;
export const SSH_DISCONNECT_RESERVED = 4;
export const SSH_DISCONNECT_MAC_ERROR = 5;
export const SSH_DISCONNECT_COMPRESSION_ERROR = 6;
export const SSH_DISCONNECT_SERVICE_NOT_AVAILABLE = 7;
export const SSH_DISCONNECT_PROTOCOL_VERSION_NOT_SUPPORTED = 8;
export const SSH_DISCONNECT_HOST_KEY_NOT_VERIFIABLE = 9;
export const SSH_DISCONNECT_CONNECTION_LOST = 10;
export const SSH_DISCONNECT_BY_APPLICATION = 11;
export const SSH_DISCONNECT_TOO_MANY_CONNECTIONS = 12;
export const SSH_DISCONNECT_AUTH_CANCELLED_BY_USER = 13;
export const SSH_DISCONNECT_NO_MORE_AUTH_METHODS_AVAILABLE = 14;
export const SSH_DISCONNECT_ILLEGAL_USER_NAME = 15;

// ── Channel open failure reason codes (RFC 4254 §5.1) ─────────────

export const SSH_OPEN_ADMINISTRATIVELY_PROHIBITED = 1;
export const SSH_OPEN_CONNECT_FAILED = 2;
export const SSH_OPEN_UNKNOWN_CHANNEL_TYPE = 3;
export const SSH_OPEN_RESOURCE_SHORTAGE = 4;

// ── Extended data type codes (RFC 4254 §5.2) ──────────────────────

export const SSH_EXTENDED_DATA_STDERR = 1;

// ── OpenSSH transport-level ping/pong ──────────────────────────────

export const SSH_MSG_PING = 192;
export const SSH_MSG_PONG = 193;

// ── Algorithm identifiers ──────────────────────────────────────────

export const KEX_ALGORITHMS = ['curve25519-sha256', 'curve25519-sha256@libssh.org'] as const;

export const HOST_KEY_ALGORITHMS = ['ssh-ed25519', 'rsa-sha2-256', 'rsa-sha2-512'] as const;

export const CIPHER_ALGORITHMS = ['aes128-gcm@openssh.com'] as const;

// GCM is AEAD, so MAC is implicit — but we still need to negotiate
// a MAC algorithm. "none" is not valid before encryption is active,
// so we advertise a real one even though it won't be used with GCM.
export const MAC_ALGORITHMS = ['hmac-sha2-256'] as const;

export const COMPRESSION_ALGORITHMS = ['none'] as const;

// ── Client version string ──────────────────────────────────────────

export const CLIENT_VERSION = 'SSH-2.0-ts-ssh2_0.0.1';

// ── Limits ─────────────────────────────────────────────────────────

/** Maximum uncompressed payload size (RFC 4253 §6.1) */
export const MAX_PACKET_PAYLOAD = 32768;

/** Maximum total packet size (RFC 4253 §6.1) */
export const MAX_PACKET_SIZE = 35000;

/** Minimum packet padding (RFC 4253 §6) */
export const MIN_PADDING = 4;

/** Maximum packet padding (RFC 4253 §6) */
export const MAX_PADDING = 255;

/** Default channel window size (2 MiB — matches OpenSSH default) */
export const DEFAULT_CHANNEL_WINDOW_SIZE = 2 * 1024 * 1024;

/** Default channel max packet size (32 KiB) */
export const DEFAULT_CHANNEL_MAX_PACKET = 32768;
